import React from "react";

import { GlobalAlerts } from "types/app";
import AlertAutoDismissable, { AlertAutoDismissableProps } from "./alert_auto_dismisable";

type AlertsProps = {
  alerts: GlobalAlerts;
  removeAlert: (alertKey: string) => void;
};

const Alerts = ({ alerts, removeAlert }: AlertsProps) => {
  const handleAlertDismiss = (alertKey: string) => {
    removeAlert(alertKey);
  };

  const autoDismissableAlerts = Object.keys(alerts).map(key => {
    const alert = alerts[key];

    return (
      <AlertAutoDismissable
        key={key}
        alertKey={key}
        type={alert?.type as AlertAutoDismissableProps["type"]}
        message={alert?.message}
        delay={alert?.delay}
        dismissAlert={handleAlertDismiss}
      />
    );
  });

  return <div>{autoDismissableAlerts}</div>;
};

export default Alerts;
